import { render, staticRenderFns } from "./AccountDropdown.vue?vue&type=template&id=8be31426&scoped=true&"
import script from "./AccountDropdown.vue?vue&type=script&lang=js&"
export * from "./AccountDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AccountDropdown.vue?vue&type=style&index=0&id=8be31426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be31426",
  null
  
)

export default component.exports